import React from 'react';
import { Homepage } from './Homepage';
import { ProductHomepage } from './ProductHomepage';
const Home = _ref => {
  let {
    productId
  } = _ref;
  if (productId) {
    return /*#__PURE__*/React.createElement(ProductHomepage, {
      productId: productId
    });
  }
  return /*#__PURE__*/React.createElement(Homepage, null);
};
export default Home;